module.exports = __webpack_public_path__ + "img/EmptyUnprocessedList.2c279d81.svg";